/**
 * When using html content in slots in components which have
 * scoped style you need to add the scope class to the html tags manually.
 * This function does that for you.
 */
export const scopify = (content, tags = [], scopeClass) => {
    if (!(content && tags.length > 0 && scopeClass))
        return content;
    const html = document.createElement('div');
    html.innerHTML = content;
    tags.forEach(tag => html
        .querySelectorAll(tag)
        .forEach(elem => elem.classList.add(scopeClass)));
    return html.innerHTML;
};
//# sourceMappingURL=scopify.js.map